// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = "/";
const ROOTS_DASHBOARD = "/";
// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  Login: path(ROOTS_AUTH, "login"),
  signup: "https://app.cribsfinder.com",
  welcome: path(ROOTS_AUTH, "welcome"),
  forgotPassword: path(ROOTS_AUTH, "forgot-password"),
  resetPassword: path(ROOTS_AUTH, "reset-password"),
  verify: path(ROOTS_AUTH, "verify"),
  setPassword: path(ROOTS_AUTH, "set-password"),
};

export const PATH_PAGE = {
  page404: "404",
  errorOccured: "500",
  home: "https://cribsfinder.com",
  privacy: "https://cribsfinder.com/privacy",
  terms: "https://cribsfinder.com/terms",
  paymentTerms: "https://cribsfinder.com/payment-terms",
  vendorSignup: "https://vendor.cribsfinder.com/signup",
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    root: path(ROOTS_DASHBOARD, ""),
    settings: path(ROOTS_DASHBOARD, "settings"),
    security: path(ROOTS_DASHBOARD, "settings/security"),
    notification: path(ROOTS_DASHBOARD, "settings/notification"),
    insights: path(ROOTS_DASHBOARD, "settings/insight"),
    privacy: path(ROOTS_DASHBOARD, "settings/privacy"),
    subscriptions: path(ROOTS_DASHBOARD, "settings/subscriptions"),
    account: path(ROOTS_DASHBOARD, "settings/profile"),
    payment: path(ROOTS_DASHBOARD, "settings/payment"),
  },
  bookings: path(ROOTS_DASHBOARD, "bookings"),
  reviews: path(ROOTS_DASHBOARD, "reviews"),
  messages: path(ROOTS_DASHBOARD, "messages"),
  transactions: path(ROOTS_DASHBOARD, "transactions"),
  wishlist: path(ROOTS_DASHBOARD, "wishlist"),
  billPayments: path(ROOTS_DASHBOARD, "bill-payments"),
  referral: path(ROOTS_DASHBOARD, "referral"),
  misc: {
    log: path(ROOTS_DASHBOARD, "log"),
    support: path(ROOTS_DASHBOARD, "support"),
    sendSupport: path(ROOTS_DASHBOARD, "support/send"),
    onboarding: path(ROOTS_DASHBOARD, "onboarding"),
  },
};

export const frontendPages = [
  "/login",
  "/signup",
  "/forgot-password",
  "/reset-password",
  "/404",
];
